import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Link
} from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

import Downloads from './pages/Downloads';
import Loading from './components/Loading.js';
import LogoHome from './assets/images/logo-home.png';
import DownloadsIcon from './assets/images/bt-download.png';
import { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';

// Lazy-loaded pages
const HomePage = lazy(() => import('./pages/Home'));
const EvolutionPage = lazy(() => import('./pages/Evolution'));
const EntreprisesEmploisPage = lazy(() => import('./pages/EntreprisesEmplois'));
const DurabilityPage = lazy(() => import('./pages/Durability'));
const TransmissionPage = lazy(() => import('./pages/Transmission'));
const FormationPage = lazy(() => import('./pages/Formation'));
const ClustersPage = lazy(() => import('./pages/Clusters'));

// Layout with header/navigation
function Layout() {
  const location = useLocation();
  const [isPortrait, setIsPortrait] = useState(window.matchMedia("(orientation: portrait)").matches);
  const [menuOpen, setMenuOpen] = useState(false);

  console.log('App version 2.0.0 — build time: 2026-04-15');

  useEffect(() => {
    const mql = window.matchMedia("(orientation: portrait)");
    const handleOrientationChange = (e) => setIsPortrait(e.matches);

    mql.addEventListener('change', handleOrientationChange);
    return () => mql.removeEventListener('change', handleOrientationChange);
  }, []);

  const navLinks = (
    <>
      <li><Link to="evolution" onClick={() => setMenuOpen(false)}>Évolution
        {location.pathname.includes('evolution') && <motion.div layoutId='tab-indicator' className='activeTabIndicator' />}
      </Link></li>
      <li><Link to="entreprises-emplois" onClick={() => setMenuOpen(false)}>Entreprises & Emplois
        {location.pathname.includes('entreprises-emplois') && <motion.div layoutId='tab-indicator' className='activeTabIndicator' />}
      </Link></li>
      <li><Link to="durability" onClick={() => setMenuOpen(false)}>Durabilité
        {location.pathname.includes('durability') && <motion.div layoutId='tab-indicator' className='activeTabIndicator' />}
      </Link></li>
      <li><Link to="transmission" onClick={() => setMenuOpen(false)}>Transmission
        {location.pathname.includes('transmission') && <motion.div layoutId='tab-indicator' className='activeTabIndicator' />}
      </Link></li>
      <li><Link to="formation" onClick={() => setMenuOpen(false)}>Formation
        {location.pathname.includes('formation') && <motion.div layoutId='tab-indicator' className='activeTabIndicator' />}
      </Link></li>
      <li><Link to="clusters" onClick={() => setMenuOpen(false)}>Clusters
        {location.pathname.includes('clusters') && <motion.div layoutId='tab-indicator' className='activeTabIndicator' />}
      </Link></li>
    </>
  );

  return (
    <>
      <header className='header'>
        {isPortrait ? (
          <button className="burgerButton" onClick={() => setMenuOpen(true)}>
            ☰
          </button>
        ) : (
          <Link to="."><img src={LogoHome} alt="Home" /></Link>
        )}

        {!isPortrait && (
          <nav>
            <ul>{navLinks}</ul>
          </nav>
        )}

        <a href="/download/3537_CDM_Chiffres_2025_RZ_web.pdf" target="_blank" rel="noopener noreferrer"><img src={DownloadsIcon} alt="Downloads" /></a>
        
      </header>

      <AnimatePresence>
        {menuOpen && isPortrait && (
          <motion.div
            className="overlayMenu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <button className="closeButton" onClick={() => setMenuOpen(false)}>×</button>
            <nav>
              <ul>
                <li><Link onClick={() => setMenuOpen(false)} to="./">Accueil</Link></li>
                {navLinks}</ul>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>

      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    </>
  );
}

// Router config
const router = createBrowserRouter([
  {
    path: "",
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "evolution", element: <EvolutionPage /> },
      { path: "entreprises-emplois", element: <EntreprisesEmploisPage /> },
      { path: "durability", element: <DurabilityPage /> },
      { path: "transmission", element: <TransmissionPage /> },
      { path: "formation", element: <FormationPage /> },
      { path: "clusters", element: <ClustersPage /> },
      { path: "downloads", element: <Downloads /> }
    ]
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
